import React from 'react';
import { useController } from 'react-hook-form';
import { Box, TextField } from '@mui/material';

const operatorOptions = ['<', '~', '~', '~', '>'];
const colors = ['#f44336', '#ff9800', '#ffeb3b', '#03a9f4', '#4caf50'];

export default function RangeInputGroup({ control, name }) {
    const { field } = useController({ name, control });

    const segments = field.value.split(';');

    const handleChange = (index, subIndex, newValue) => {
        const updatedSegments = [...segments];
        const values = updatedSegments[index]?.split(',') || ['0', '0'];
        //values[subIndex] = newValue;
        values[subIndex] = Boolean(newValue) ? newValue:'0';
        updatedSegments[index] = values.join(',');
        field.onChange(updatedSegments.join(';'));
    };

    return (
        <Box display="flex" flexDirection="column" gap={1}>
            {segments.map((seg, idx) => {
                const [val1, val2] = seg.split(',').map(v => v.trim());
                const operator = operatorOptions[idx];

                return (
                    <Box key={idx} display="flex" alignItems="center" gap={1}>
                        {operator === '<' && (
                            <>
                                <TextField
                                    size="small"
                                    type="number"
                                    value={0}
                                    disabled
                                    //   onChange={(e) => handleChange(idx, 0, e.target.value)}
                                    sx={{ width: 80 }}
                                />
                                <Box>{'~'}</Box>
                                <TextField
                                    size="small"
                                    type="number"
                                    value={val1}
                                    onChange={(e) => handleChange(idx, 0, e.target.value)}
                                    sx={{ width: 80 }}
                                />
                            </>
                        )}
                        {operator === '~' && (
                            <>
                                <TextField
                                    size="small"
                                    type="number"
                                    value={val1}
                                    onChange={(e) => handleChange(idx, 0, e.target.value)}
                                    sx={{ width: 80 }}
                                />
                                <Box>{'~'}</Box>
                                <TextField
                                    size="small"
                                    type="number"
                                    value={val2}
                                    onChange={(e) => handleChange(idx, 1, e.target.value)}
                                    sx={{ width: 80 }}
                                />
                            </>
                        )}
                        {operator === '>' && (
                            <>
                                <TextField
                                    size="small"
                                    type="number"
                                    value={val1}
                                    onChange={(e) => handleChange(idx, 0, e.target.value)}
                                    sx={{ width: 80 }}
                                />
                                <Box>{'~'}</Box>
                                <TextField
                                    size="small"
                                    type="number"
                                    value={0}
                                    disabled
                                    //   onChange={(e) => handleChange(idx, 0, e.target.value)}
                                    sx={{ width: 80 }}
                                />
                            </>
                        )}
                        <Box sx={{ width: 32, height: 32, bgcolor: colors[idx], borderRadius: 1 }} />
                    </Box>
                );
            })}
        </Box>
    );
}
